import Wishlist from "./wishlist";

const WishlistDataContainer = (props) => {
  return <Wishlist {...props} fetchArr={props.wishlistData} />;
};

export default WishlistDataContainer;
